module.exports = __webpack_public_path__ + "img/8-Guy_W_The_Cap LEFT-half.2d12c48.png";